import {
    Col,
    Row,
    Input,
    Form,
    Card,
    Collapse,
    Select,
    Button,
    Switch,
    Tooltip,
} from 'antd'
import commonStyles from '../../../../Utils/Common.less'
import partneshipTraderNewStyles from '../../../../Less/Clients/RegisteredClients/SoleTrader/SoleTraderNew.less'
import { connect, useDispatch } from 'react-redux'
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { GetCategoryDropDownList } from '../../../../Services/GroupAndPartners'
import { GetCountryList } from '../../../../Services/Common'
import { SaveOutlined } from '@ant-design/icons'
import {
    type PartneshipHomeApi,
    type PartnershipFormInterface,
} from '../../../../Types/Client/RegisteredClients/Partnership'
import { SavePartnershipData } from '../../../../Services/Parnership'
import { type ListFrontEndInterface } from '../../../../Types/CommonType'
import PostCodeInput from '../../../../Components/PostCodeInput'

const PartnershipNew = (
    props: PartnershipFormInterface
): React.ReactElement => {
    const { categoryDropDownList, countryList } = props
    const location = useLocation()
    const onbordingId = location.state?.onbordingId
    const [form] = Form.useForm()
    const [collapseOne, SetCollapseOne] = useState<string[] | string>(['1'])
    const [collapseTwo, SetCollapseTwo] = useState<string[] | string>([])
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const [address, setAddress] = useState({
        line_1: '',
        line_2: '',
        line_3: '',
        post_town: '',
        postcode: '',
        country: '',
    })

    useEffect(() => {
        const countryData = countryList?.find(
            (data: ListFrontEndInterface) =>
                data.label === address?.country?.toUpperCase()
        )
        if (address.line_1 !== '') {
            if (collapseTwo === '2') {
                const AddressData = {
                    busAddressOne: address.line_1,
                    busAddressTwo: address.line_2,
                    busTown: address.post_town,
                    busCountry: countryData?.label ?? '',
                    busPostCode: address.postcode,
                }
                form.setFieldsValue(AddressData)
            } else {
                const AddressData = {
                    corrAddressOne: address.line_1,
                    corrAddressTwo: address.line_2,
                    corrTown: address.post_town,
                    corrCountry: countryData?.label ?? '',
                    corrPostCode: address.postcode,
                }
                form.setFieldsValue(AddressData)
            }
        }
    }, [address])

    useEffect(() => {
        GetCategoryDropDownList(dispatch)
        GetCountryList(dispatch)
    }, [dispatch, Form])
    useEffect(() => {
        form.setFieldsValue({
            busCountry: 'UNITED KINGDOM',
            corrCountry: 'UNITED KINGDOM',
        })
    }, [])
    const customizeRequiredMark = (
        label: React.ReactNode,
        { required }: { required: boolean }
    ): React.ReactElement => (
        <>
            {label}
            &nbsp;
            {required && <span className={commonStyles.requireIcon}>*</span>}
        </>
    )

    const saveCallBack = (data: PartneshipHomeApi): void => {
        localStorage.setItem('partnerTapId', '1')

        navigate(
            onbordingId === 1
                ? `/clients/registered-clients/partnership-view`
                : '/clients/onboarding-clients/partnership-view',
            {
                state: { partnershipData: data, onbordingId },
            }
        )
    }

    const onSavePartner = (data: PartneshipHomeApi): void => {
        void SavePartnershipData(dispatch, data, saveCallBack)
    }

    const collapseOneOnChange = (data: string | string[]): void => {
        SetCollapseOne(data)
        if (collapseTwo.length > 0) {
            SetCollapseTwo([])
        }
    }

    const collapseTwoOnChange = (data: string | string[]): void => {
        SetCollapseTwo(data)
        if (collapseOne.length > 0) {
            SetCollapseOne([])
        }
    }

    const initialDetails = (): React.ReactElement => {
        return (
            <div>
                <Form.Item<PartneshipHomeApi>
                    name="partnershipId"
                    hidden={true}
                >
                    <Input allowClear />
                </Form.Item>

                <Form.Item<PartneshipHomeApi>
                    label="Client Category"
                    name="clientCategoryId"
                    rules={[
                        {
                            required: true,
                            message: 'Please Select Client Category',
                        },
                    ]}
                    initialValue={1}
                >
                    <Select
                        placeholder="Please select"
                        options={[...categoryDropDownList]}
                        defaultValue={1}
                        filterOption={(input, option) =>
                            option?.label
                                ?.toLowerCase()
                                .includes(input.toLowerCase()) ?? false
                        }
                        allowClear
                        showSearch
                    />
                </Form.Item>
                <Form.Item<PartneshipHomeApi>
                    label="Trading Name"
                    name="tradingName"
                    rules={[
                        {
                            required: true,
                            message: 'Please Enter Trading Name',
                        },
                    ]}
                >
                    <Input allowClear />
                </Form.Item>
                <Form.Item<PartneshipHomeApi>
                    label="Partnership UTR"
                    name="partnershipUTR"
                >
                    <Input allowClear />
                </Form.Item>
            </div>
        )
    }

    const businessAddress = (): React.ReactElement => {
        return (
            <div>
                <Form.Item<PartneshipHomeApi>
                    label="Address 1"
                    name="busAddressOne"
                    rules={[
                        {
                            required: true,
                            message: 'Please Enter Address1',
                        },
                    ]}
                >
                    <Input allowClear maxLength={200} />
                </Form.Item>
                <Form.Item<PartneshipHomeApi>
                    label="Address 2"
                    name="busAddressTwo"
                >
                    <Input allowClear maxLength={200} />
                </Form.Item>
                <Form.Item<PartneshipHomeApi>
                    label="Town"
                    name="busTown"
                    rules={[
                        {
                            required: true,
                            message: 'Please Enter Town',
                        },
                    ]}
                >
                    <Input allowClear maxLength={50} />
                </Form.Item>
                <Form.Item<PartneshipHomeApi>
                    label="Country"
                    name="busCountry"
                    initialValue="UNITED KINGDOM"
                    rules={[
                        {
                            required: true,
                            message: 'Please Select Country',
                        },
                    ]}
                >
                    <Select
                        allowClear
                        showSearch
                        placeholder="Please select"
                        onChange={() => {}}
                        optionFilterProp="children"
                        options={countryList?.map((data: { label: string }) => {
                            return {
                                id: data.label,
                                value: data.label,
                                label: data.label,
                            }
                        })}
                    />
                </Form.Item>

                <PostCodeInput
                    name="busPostCode"
                    label="Post Code"
                    reuireMessage="Please Enter Post Code"
                    placeHolder={''}
                    setAddressDetails={setAddress}
                />
            </div>
        )
    }

    const onChangeCABusiness = (checked: boolean): void => {
        let corrAddress1 = ''
        let corrAddress2 = ''
        let corrTown = ''
        let corrCountry = ''
        let corrPostCode = ''
        if (checked) {
            corrAddress1 = form.getFieldValue('busAddressOne')
            corrAddress2 = form.getFieldValue('busAddressTwo')
            corrTown = form.getFieldValue('busTown')
            corrCountry = form.getFieldValue('busCountry')
            corrPostCode = form.getFieldValue('busPostCode')
        }
        form.setFieldValue('corrAddressOne', corrAddress1)
        form.setFieldValue('corrAddressTwo', corrAddress2)
        form.setFieldValue('corrTown', corrTown)
        form.setFieldValue('corrCountry', corrCountry)
        form.setFieldValue('corrPostCode', corrPostCode)
        void form.validateFields()
    }

    const correspondAddress = (): React.ReactElement => {
        return (
            <div>
                <div className={partneshipTraderNewStyles.cpAddressMain}>
                    <div>
                        <Switch size="small" onChange={onChangeCABusiness} />
                        &nbsp;
                        <label className={commonStyles.colorGray}>
                            Same as Business
                        </label>
                    </div>
                </div>
                <Form.Item<PartneshipHomeApi>
                    label="Address 1"
                    name="corrAddressOne"
                    rules={[
                        {
                            required: true,
                            message: 'Please Enter Address1',
                        },
                    ]}
                >
                    <Input allowClear maxLength={200} />
                </Form.Item>
                <Form.Item<PartneshipHomeApi>
                    label="Address 2"
                    name="corrAddressTwo"
                >
                    <Input allowClear maxLength={200} />
                </Form.Item>
                <Form.Item
                    label="Town"
                    name="corrTown"
                    rules={[
                        {
                            required: true,
                            message: 'Please Enter Town',
                        },
                    ]}
                >
                    <Input allowClear maxLength={50} />
                </Form.Item>
                <Form.Item<PartneshipHomeApi>
                    label="Country"
                    name="corrCountry"
                    initialValue="UNITED KINGDOM"
                    rules={[
                        {
                            required: true,
                            message: 'Please Select Country',
                        },
                    ]}
                >
                    <Select
                        allowClear
                        showSearch
                        placeholder="Please select"
                        onChange={() => {}}
                        optionFilterProp="children"
                        options={countryList?.map((data: { label: string }) => {
                            return {
                                id: data.label,
                                value: data.label,
                                label: data.label,
                            }
                        })}
                    />
                </Form.Item>

                <PostCodeInput
                    name="corrPostCode"
                    label="Post Code"
                    reuireMessage="Please Enter Post Code"
                    placeHolder={''}
                    setAddressDetails={setAddress}
                />
            </div>
        )
    }
    const onFinishFailed = ({ errorFields }: any): void => {
        SetCollapseOne(['1', '2'])
        SetCollapseTwo(['2', '3'])
    }
    return (
        <Card className={commonStyles.card}>
            <Form
                name="complex-form"
                layout={'vertical'}
                autoComplete="off"
                form={form}
                requiredMark={customizeRequiredMark}
                onFinish={onSavePartner}
                onFinishFailed={onFinishFailed}
            >
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item label="Client Type">
                            <Input disabled value={'Partnership'} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="Client No" name="clientNumber">
                            <Input disabled />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item label="Client Name">
                            <Input disabled />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="Trading Name" name="tradingName">
                            <Input disabled />
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <h3>Basic Information</h3>
                </Row>
                <div className={commonStyles.flexDirectionRow}>
                    <div className={partneshipTraderNewStyles.collapseFirst}>
                        <Collapse
                            activeKey={collapseOne}
                            onChange={collapseOneOnChange}
                            bordered={true}
                        >
                            <Collapse.Panel
                                key="1"
                                header={`Initial Details`}
                                forceRender
                            >
                                {initialDetails()}
                            </Collapse.Panel>
                        </Collapse>
                    </div>
                    <div className={partneshipTraderNewStyles.collapseSecond}>
                        <Collapse
                            activeKey={collapseTwo}
                            onChange={collapseTwoOnChange}
                            bordered={true}
                        >
                            <Collapse.Panel
                                key="2"
                                header={`Business Address`}
                                forceRender
                            >
                                {businessAddress()}
                            </Collapse.Panel>
                            <Collapse.Panel
                                key="3"
                                header={`Correspondence Address`}
                                forceRender
                            >
                                {correspondAddress()}
                            </Collapse.Panel>
                        </Collapse>
                    </div>
                </div>
                &nbsp;
                <Row gutter={16}>
                    <Col offset={22} span={1}>
                        <Tooltip title="Save Client Details">
                            <Button type="primary" htmlType="submit">
                                <SaveOutlined />
                            </Button>
                        </Tooltip>
                    </Col>
                </Row>
            </Form>
        </Card>
    )
}

const mapStateToProps = (state: any): PartnershipFormInterface => {
    return {
        categoryDropDownList: state.initial.categoryDropDownList,
        countryList: state.common.countryList,
        clientDropDownList: state.client.clientDropDownList,
    }
}

export default connect(mapStateToProps)(PartnershipNew)
